// @ts-nocheck
/* eslint-disable */
export const boldArrowRightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M10.133 6.993 8.82 5.68 6.68 3.54a.721.721 0 0 0-1.227.513v7.894c0 .64.774.96 1.227.507L10.133 9a1.42 1.42 0 0 0 0-2.007"/></svg>`,
    name: 'bold-arrow-right' as const
};